module.exports = __webpack_public_path__ + "static/media/modal_marcar_como_lido.28ad43cc.png";